import * as AuthActions from './AuthActions';
import * as LayoutActions from './LayoutActions';
import * as DashboardActions from './DashboardActions';
import * as JobActions from './JobActions';
import * as TypeActions from './TypeActions';
import * as LocationActions from './LocationActions';
import * as UserActions from './UserActions';
import * as ReportActions from './ReportActions';
import * as CompanyActions from './CompanyActions';
import * as ModalActions from './ModalActions';


const Actions = {
    auth: AuthActions,
    layout: LayoutActions,
    dashboard: DashboardActions,
    jobs: JobActions,
    types: TypeActions,
    locations: LocationActions,
    users: UserActions,
    reports: ReportActions,
    companies: CompanyActions,
    modals: ModalActions,
};

export default Actions;


// WEBPACK FOOTER //
// ./src/Actions/index.js